// File ordering within each folder for react-on-rails
// Files listed here appear in this order; unlisted files appear after, alphabetically
const reactOnRailsFileOrder = {
  "getting-started": [
    "introduction",
    "quick-start",
    "installation-into-an-existing-rails-app",
    "tutorial",
    "using-react-on-rails",
    "project-structure",
  ],
  "core-concepts": [
    "how-react-on-rails-works",
    "client-vs-server-rendering",
    "render-functions",
    "render-functions-and-railscontext",
    "react-server-rendering",
    "auto-bundling-file-system-based-automated-bundle-generation",
    "webpack-configuration",
  ],
  "building-features": [
    // Group 1: Development Workflow
    "hmr-and-hot-reloading-with-the-webpack-dev-server",
    "foreman-issues",
    // Group 2: Common Features
    "react-router",
    "react-and-redux",
    "i18n",
    "images",
    "react-helmet",
    // Group 3: Testing
    "testing-configuration",
    // Group 4: Advanced
    "code-splitting",
    "streaming-server-rendering",
    "how-to-conditionally-server-render-based-on-device-type",
    "how-to-use-different-files-for-client-and-server-rendering",
    "rails-webpacker-react-integration-options",
    "turbolinks",
  ],
  "api-reference": [
    "view-helpers-api",
    "javascript-api",
    "redux-store-api",
    "generator-details",
    "rails_view_rendering_from_inline_javascript",
  ],
  "deployment": [
    "heroku-deployment",
    "capistrano-deployment",
    "elastic-beanstalk",
    "server-rendering-tips",
    "troubleshooting",
    "troubleshooting-build-errors",
    "troubleshooting-when-using-shakapacker",
    "troubleshooting-when-using-webpacker",
  ],
  "migrating": [
    "migrating-from-react-rails",
    "angular-js-integration-migration",
    "convert-rails-5-api-only-app",
  ],
  "pro": [
    "react-on-rails-pro",
    "major-performance-breakthroughs-upgrade-guide",
  ],
}

const fileOrderByRepo = {
  "react-on-rails": reactOnRailsFileOrder,
}

exports.fileOrderByRepo = fileOrderByRepo
